import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import { Question } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface FilterQuestionsByUseCase {
  invoke: (queryString: string) => Promise<ResponseState<Array<Question>>>;
}

export class FilterQuestionsByUseCaseImpl implements FilterQuestionsByUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(queryString: string): Promise<ResponseState<Array<Question>>> {
    try {
      let response = await this.questionRepository.filterQuestionsBy(
        queryString
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
